import React, { useEffect, useState } from 'react';
import './AnalyzeBrand.scss';
import chatBotImg from '../../../assets/icons/2150849173 1.png';
import robot from '../../../assets/images/robot 1.png';
import GenerateReport from './GenerateReport/GenerateReport';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { auth, firestoredb } from "../../../config";
import { doc, getDoc, updateDoc } from "firebase/firestore";

const AnalyzeBrands = () => {
    const [showBrandForm, setShowBrandForm] = useState(true);
    const [showGenerateReport, setShowGenerateReport] = useState(false);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [nextClicked, setNextClicked] = useState(false);
    const [ourBrand, setOurBrand] = useState({});
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const user = auth.currentUser


    const questions = [
        'What do you provide? e.g: Products or Services.',
        'Who is the competitor you compare your brand with? ',
        'What platform are you focusing on? Social media or website or both.',
        'Do you want to bring traffic on a certain platform?',
        'What is the special feature that you think distinguishes your brand from the other?',
    ];

    const handleNextQuestion = () => {
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
        } else if (questions.length >= 5) {
            setShowBrandForm(true);
        } else {
            setShowGenerateReport(true);
        }

        setNextClicked(true);
    };

    const handlePrevQuestion = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex((prevIndex) => prevIndex - 1);
        }
    };
    const handleInputChangeOurBrand = (e) => {
        setOurBrand(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }
    function validateAndFormatURL(inputURL) {
        // Remove protocols (http, https, etc.)
        let cleanedURL = inputURL.replace(/^(https?:|ftp:)?\/\/(www\.)?/, '');

        // Add 'www.' if not present
        if (!cleanedURL.startsWith('www.')) {
            cleanedURL = 'www.' + cleanedURL;
        }

        // Ensure the URL ends with a domain (e.g., ".com")


        return cleanedURL;
    }
    const startComparing = async () => {
        let instagramPosts = ""
        try {
            setLoading(true);

            const resultOwnBrand = await axios.post(process.env.REACT_APP_SERVER_URL + "/instagramanalysis", { username: ourBrand.instagramUrl })
            instagramPosts = resultOwnBrand.data.postData.map((hehe) => (
                {
                    caption: hehe.caption,
                    instaComments: hehe.instaComments,
                    instaLikes: hehe.instaLikes,
                    instaPlayCount: hehe.instaPlayCount,
                    instaReshareCount: hehe.instaReshareCount


                }
            ))
            setOurBrand((prev) => ({ ...prev, instagramResults: resultOwnBrand.data }))
            setLoading(false);

        } catch {
            alert("Error");
            setLoading(false);

        }
        try {

            setLoading(true);

            const resultOwnBrand = await axios.post(process.env.REACT_APP_SERVER_URL + "/linkedinanalysis", { linkedinUrl: ourBrand.linkedinUrl })
            setOurBrand((prev) => ({ ...prev, linkedinResults: resultOwnBrand.data }))
            setLoading(false);

        } catch {
            alert("Error");
            setLoading(false);

        }

        handleGptRequest(JSON.stringify(instagramPosts));


    }

    // POC

    const handleGptRequest = async (instagramPosts) => {
        if (ourBrand.webUrl) {
            try {
                setLoading(true);

                // setLoading(true)
                // setCompetitorBrand("")
                // const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
                //     domain: ourBrand.webUrl
                // })
                // const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
                //     domain: validateAndFormatURL(ourBrand.webUrl)
                // })
                console.log("h", validateAndFormatURL(ourBrand.webUrl))
                const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
                    domain: validateAndFormatURL(ourBrand.webUrl),
                    instagramData: instagramPosts
                })
                // handleGptRequestCompetitor(response.data);
                // const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
                //     domain: url
                // })
                setOurBrand((prev) => ({ ...prev, mainAnalysis: response.data }))
                // setLoading(false)
                try {
                    setLoading(true);

                    // setReviewsLoader(true)
                    // const reviews = await axios.post(process.env.REACT_APP_SERVER_URL + "/getBrandsReviews",
                    //     {
                    //         domain: ourBrand.webUrl
                    //     }

                    // )
                    const reviews = await axios.post(process.env.REACT_APP_SERVER_URL + "/getBrandsReviews",
                        {
                            domain: validateAndFormatURL(ourBrand.webUrl)
                        }

                    )
                    if (reviews.data) {
                        if (!reviews.data.message) {
                            setOurBrand((prev) => ({ ...prev, reviews: reviews.data }))
                        }
                        else {
                            setOurBrand((prev) => ({ ...prev, reviews: false }))

                        }
                    }
                    // setReviewsLoader(false)
                    setLoading(false);
                    setDone(true);

                }
                catch (e) {
                    console.log("here in catch reviews");
                    console.log("Error", e);
                    // setReviewsLoader(false)
                    setLoading(false);

                }
                // setLoading(false)
            }
            catch (e) {
                console.log("Error", e);
                // setLoading(false)
                setLoading(false);

            }
            finally {
                setLoading(false);
            }

        }
        else {
            alert("Please Enter a Valid Url")
        }

    }
    const handleDbSave = async () => {
        try {
            //fetching previous data first
            if (user) {
                // // console.log("Fetching Data from DB");
                const docRef = doc(firestoredb, "users", user.uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    // // console.log("Document data gs:", docSnap.data());
                    if (docSnap.data().brandAnalysis) {

                        let brandAnalysis = docSnap.data().brandAnalysis;
                        console.log("What's saving", ourBrand);
                        await updateDoc(docRef, {
                            brandAnalysis: [
                                ...brandAnalysis,
                                {
                                    ...ourBrand, reviews: {}
                                }
                            ],
                        });
                        console.log("Data Successfully save to Database");
                    }
                    else {
                        console.log("What's saving", ourBrand);

                        await updateDoc(docRef, {
                            brandAnalysis: [
                                {
                                    ...ourBrand, reviews: {}
                                }
                            ],
                        });
                        console.log("Data Successfully save to Database");
                    }
                }
            }
        }
        catch (error) {
            console.log("Error while saving to Database");
            console.log(error);
        }
    }

    useEffect(() => {
        console.log("ourBrand", ourBrand);

    }, [ourBrand])

    useEffect(() => {
        if (done) {

            handleDbSave();
        }
    }, [done])

    return (
        <div>
            {!showBrandForm ? (
                <div className='analyzeBrands-container'>
                    <div className='analyzeBrands-box position-relative'>
                        <div className='d-flex align-items-center'>
                            <img src={chatBotImg} alt='' />
                            <h6>ChatBot</h6>
                        </div>
                        <p className='question'>{questions[currentQuestionIndex]}</p>
                        <input type='text' placeholder='Type your answer....' />
                        <div className='d-flex justify-content-between align-items-center'>
                            {nextClicked && (
                                <button className='white-theme-btn' onClick={handlePrevQuestion}>
                                    Prev
                                </button>
                            )}
                            <button className='dark-theme-btn' onClick={handleNextQuestion}>
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            ) : !showGenerateReport ? (
                <div className='brandForm-container customScroller-transparent'>
                    {/* <div className='brandForm-left-container'>
                        <img src={robot} alt='' />
                    </div> */}
                    <div className='brandForm-right-container'>
                        <h5>Brand Information for Comparative Data Analysis</h5>
                        <p>Your Input Matters! Help Us Compare Brands for Informed Insights</p>
                        <div className='mt-5 w-100 d-flex justify-content-between brandFlex'>
                            <span style={{ width: "100%" }}>
                                {/* <label>Brand Name</label>
                                <br />
                                <input type='text' />
                                <br /> */}
                                <label className='mt-3' style={{ width: "100%" }}>Website URL</label>
                                <br />
                                <input type='text' style={{ width: "100%" }} name="webUrl" onChange={handleInputChangeOurBrand} />
                            </span>
                            {/* <div className='brandFlex-logo-upload'>
                                <label>Logo</label>
                                <label className='upload-container'>
                                    <span>+ Add logo</span>
                                    <input type='file' id='fileInput' />
                                </label>
                            </div> */}
                        </div>
                        <div className='social-inputs-brandForm w-100 d-flex justify-content-between'>
                            <div className='mt-4'>
                                <label>Social Media Links</label>
                                <br />
                                <span className='input-spans-brands'>
                                    <input type='text' placeholder='Instagram' name="instagramUrl" onChange={handleInputChangeOurBrand} />
                                    {/* <input type='text' placeholder='X' />
                                    <input type='text' placeholder='Facebook' /> */}
                                    <input type='text' placeholder='Linkedin' name="linkedinUrl" onChange={handleInputChangeOurBrand} />
                                </span>
                            </div>
                        </div>
                        <div className='d-flex justify-content-end align-items-end mt-5'>
                            <button className='dark-theme-btn' onClick={() => {
                                startComparing();
                                setShowGenerateReport(true);

                            }}>
                                Generate Report
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <GenerateReport ourBrand={ourBrand} />
            )}
            <Modal show={loading} centered>
                <Modal.Header>
                    <Modal.Title>Loading... Please wait</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <div class="lds-ringDashboard">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default AnalyzeBrands;
